<div class="trade-page">
  <div class="page-header">
    <app-page-title></app-page-title>
  </div>

  @if (hasNoBusiness()) {
    <div class="alert alert-warning d-flex flex-wrap align-items-center gap-2" role="alert">
      <i class="bi bi-shop" aria-hidden="true"></i>
      <span>ยังไม่มีข้อมูลธุรกิจสำหรับบันทึกการซื้อ-ขายสินค้าเกษตร</span>
      <button type="button" class="btn btn-link fw-semibold p-0 align-baseline" (click)="addBusiness()">
        เพิ่มข้อมูลธุรกิจ
      </button>
    </div>
  } @else {
    <!-- <div class="main-tabs-bar" role="tablist" aria-label="หมวดหมู่ข้อมูลการซื้อ-ขายสินค้าเกษตร">
      @for (tab of mainTabs; track tab.value) {
        <button type="button"
                role="tab"
                class="main-tab"
                [class.active]="activeMainTab() === tab.value"
                [attr.aria-selected]="activeMainTab() === tab.value"
                (click)="selectMainTab(tab.value)">
          <img [src]="tab.imageIcon" [alt]="tab.label" class="main-tab-img" />
          <span>{{ tab.label }}</span>
          @if (tab.value === 'RECORDS' && visibleRecords().length > 0) {
            <span class="tab-count">{{ visibleRecords().length }}</span>
          }
          @if (tab.value === 'STOCK' && stock().length > 0) {
            <span class="tab-count">{{ stock().length }}</span>
          }
          @if (tab.value === 'OFFERS' && offers().length > 0) {
            <span class="tab-count">{{ offers().length }}</span>
          }
        </button>
      }

      @if (store.businessesLoaded() && store.canRecordHarvest()) {
        <a class="btn btn-primary btn-sm btn-create-record ms-auto" [routerLink]=\"[tradeBase, 'new']\">
          <i class="bi bi-plus-lg" aria-hidden="true"></i>
          สร้างรายการขาย
        </a>
      }
    </div> -->

        <div class="toolbar-business mb-3">
      <div class="toolbar-business-info">
        @if (store.businesses().length > 1) {
          <app-trade-business-select
            class="toolbar-business-select"
            [businesses]="store.businesses()"
            [selectedId]="store.selectedBusinessId()"
            [inline]="true"
            label="เลือกธุรกิจที่ต้องการดูข้อมูล"
            inputId="trade-list-business"
            (selectedIdChange)="onBusinessChange($event)">
          </app-trade-business-select>
        } @else if (store.selectedBusiness(); as business) {
          <div class="toolbar-business-title-row">
            <strong class="toolbar-business-name">{{ business.title }}</strong>
          </div>
        }
        @if (store.selectedBusiness(); as business) {
          @if ((business.businessTypeTitles ?? []).length > 0) {
            <span class="toolbar-business-types">{{ (business.businessTypeTitles ?? []).join(' · ') }}</span>
          }
        }
      </div>
    </div>

    @if (needsBusinessChoice()) {
      <div class="trade-empty choose-business-prompt" role="status">
        <i class="bi bi-shop" aria-hidden="true"></i>
        <span>เลือกธุรกิจด้านบนเพื่อดูสินค้าคงเหลือ ใบขาย และรายการซื้อ-ขาย</span>
      </div>
    } @else {
    <h6 class="section-title mb-0">สินค้าคงเหลือ</h6>
    <section class="mb-4" aria-label="สินค้าคงเหลือ">
      @if (stock().length === 0) {
        <div class="stock-empty-state">
          <img src="assets/images/icons/stock.png" alt="สต็อกสินค้า" class="stock-empty-img" />
          <strong class="stock-empty-title">ยังไม่มีรายการสินค้าคงเหลือในสต็อก</strong>
          <span class="stock-empty-desc">เมื่อมีการบันทึกการซื้อหรือรับผลผลิต รายการสินค้าคงเหลือจะแสดงที่นี่</span>
        </div>
      } @else {
        <div class="result-line">
          พบ {{ stock().length.toLocaleString('th-TH') }} รายการ
        </div>
        <div class="stock-grid">
          @for (item of pagedStock(); track item.businessId + '|' + item.productName + '|' + item.unit) {
            <div class="card h-100 stock-card" [class.is-added]="isAddedStock(item)">
              <div class="stock-card-body">
                <div class="stock-product-header">
                  <h6 class="stock-product-name" [title]="item.productName">{{ item.productName }}</h6>
                  @if (isAddedStock(item)) {
                    <span class="stock-added-badge">
                      <i class="bi bi-check-circle-fill" aria-hidden="true"></i> เพิ่มเข้าสต็อกแล้ว
                    </span>
                  }
                  @if (store.selectedBusinessId() == null && item.businessTitle) {
                    <div class="stock-business-badge" [title]="item.businessTitle">
                      <i class="bi bi-shop" aria-hidden="true"></i>
                      <span class="text-truncate">{{ item.businessTitle }}</span>
                    </div>
                  }
                </div>

                <div class="stock-icon-box">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-package-icon lucide-package"><path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z"/><path d="M12 22V12"/><polyline points="3.29 7 12 12 20.71 7"/><path d="m7.5 4.27 9 5.15"/></svg>
                </div>

                <div class="stock-metric-box">
                  <span class="stock-metric-label">สินค้าคงเหลือ</span>
                  <div class="stock-metric-value">
                    <span class="stock-metric-num">{{ formatQuantity(displayQuantity(item)) }}</span>
                    @if (item.unit) {
                      <span class="stock-metric-unit">{{ item.unit }}</span>
                    }
                    @if (addedQuantity(item) > 0) {
                      <span class="stock-added-float" aria-hidden="true">+{{ formatQuantity(addedQuantity(item)) }} {{ shortUnit(item.unit) }}</span>
                    }
                  </div>
                </div>

                @if (canSell()) {
                  <div class="stock-actions">
                    <button type="button" class="btn btn-sm btn-stock-sell" (click)="openSell(item)">
                      <i class="bi bi-cash-coin" aria-hidden="true"></i>
                      <span>ขาย</span>
                    </button>
                    <button type="button" class="btn btn-sm btn-stock-transform" (click)="openTransform(item)">
                      <i class="bi bi-arrow-repeat" aria-hidden="true"></i>
                      <span>แปรรูป</span>
                    </button>
                  </div>
                }
              </div>
            </div>
          }
        </div>
        @if (stock().length > 5 && pagedStock().length < stock().length) {
          <div class="load-more-wrap">
            <button type="button" class="btn btn-load-more" (click)="loadMoreStock()">
              <span>เพิ่มเติม</span>
              <i class="bi bi-chevron-down" aria-hidden="true"></i>
            </button>
          </div>
        }
      }
    </section>

    <h6 class="section-title mb-0">ใบขาย</h6>
    <section class="mb-4" aria-label="ใบขาย">
      @if (offers().length === 0) {
        <div class="trade-empty">ยังไม่มีรายการใบขาย</div>
      } @else {
        <div class="result-line">
          พบ {{ offers().length.toLocaleString('th-TH') }} รายการ
        </div>
        <div class="d-flex flex-column gap-2">
          @for (offer of pagedOffers(); track offer.id) {
            <div class="offer-row card">
              <div class="card-body py-2 px-3 d-flex flex-wrap align-items-center gap-2">
                <span [class]="'pill ' + saleOfferStatusClass(offer.status)">
                  {{ saleOfferStatusLabel(offer.status) }}
                </span>
                <button type="button" class="btn btn-link btn-sm p-0 fw-semibold text-decoration-none text-start"
                        (click)="openOffer(offer)">{{ offerSummary(offer) }}
                </button>
                <span class="text-secondary small">
                  @if (offerPartiallyAccepted(offer)) {
                    รับจริง {{ formatQuantityWithUnit(offerAcceptedTotal(offer), unit) }}
                    · จากใบขาย {{ formatQuantityWithUnit(offerTotal(offer), unit) }}
                  } @else {
                    ปริมาณรวม {{ formatQuantityWithUnit(offerTotal(offer), unit) }}
                  }
                </span>
                <div class="ms-auto d-flex flex-wrap gap-1">
                  @if (offer.status === 'OPEN') {
                    <button type="button" class="btn btn-sm btn-outline-primary"
                            (click)="openOffer(offer)">
                      <i class="bi bi-qr-code" aria-hidden="true"></i> QR Code
                    </button>
                    @if (offer.canCancel) {
                      <button type="button" class="btn btn-sm btn-outline-danger"
                              (click)="cancelOffer(offer)">ยกเลิก
                      </button>
                    }
                  }
                  @if (offer.status === 'ACCEPTED') {
                    @if (offer.acceptedRecordIds?.length) {
                      <a class="btn btn-sm btn-outline-secondary"
                         [routerLink]="[tradeBase, offer.acceptedRecordIds![0]]">ดูรายการที่จำหน่ายแล้ว</a>
                    }
                  }
                </div>
              </div>
            </div>
          }
        </div>
        @if (offers().length > 5 && pagedOffers().length < offers().length) {
          <div class="load-more-wrap">
            <button type="button" class="btn btn-load-more" (click)="loadMoreOffers()">
              <span>เพิ่มเติม</span>
              <i class="bi bi-chevron-down" aria-hidden="true"></i>
            </button>
          </div>
        }
      }
    </section>

    <section class="record-section" aria-label="รายการซื้อ-ขายสินค้าเกษตร">
      <div class="listing-card">
        <div class="listing-card-header">
          <div class="header-main-row">
            <h6 class="section-title mb-0">รายการซื้อ-ขายสินค้าเกษตร</h6>
            <div class="header-actions">
              <div class="manual-code-row">
                <label class="visually-hidden" for="trade-manual-code">ระบุรหัส QR หรือรหัสใบขาย</label>
                <input id="trade-manual-code" type="text" class="form-control manual-code-input"
                       placeholder="ระบุรหัส QR หรือรหัสใบขาย..."
                       autocomplete="off" [value]="manualCode()" (input)="onManualCodeInput($event)"
                       (keydown.enter)="submitManualCode()">
                <button type="button" class="btn btn-outline-secondary manual-code-btn" (click)="submitManualCode()"
                        [disabled]="!manualCode().trim()">ตรวจสอบรหัส
                </button>
              </div>

              <button type="button" class="btn btn-default btn-sm btn-scan-action" (click)="openScanner()">
                <i class="bi bi-qr-code-scan" aria-hidden="true"></i> สแกน QR เพื่อรับสินค้า
              </button>

              @if (store.businessesLoaded() && store.canRecordHarvest()) {
                <a class="btn btn-primary btn-sm btn-create-record" [routerLink]="[tradeBase, 'new']">
                  <i class="bi bi-plus-lg" aria-hidden="true"></i>
                  สร้างรายการขาย
                </a>
              }
            </div>
          </div>

          <div class="header-toolbar-row">
            <div class="filter-search-wrap">
              <i class="bi bi-search filter-search-icon" aria-hidden="true"></i>
              <label class="visually-hidden" for="trade-search">ค้นหา</label>
              <input id="trade-search" type="text" class="form-control filter-search-input"
                     placeholder="ค้นหาชื่อสินค้า, รหัสล็อต, ชื่อฟาร์ม หรือธุรกิจ..."
                     [value]="searchInput()" (input)="onSearchInput($event)">
            </div>

<!--              <button type="button" class="btn-refresh" (click)="refresh()" [disabled]="recordsLoading()"-->
<!--                      title="โหลดข้อมูลใหม่" aria-label="โหลดข้อมูลใหม่">-->
<!--                <i class="bi bi-arrow-clockwise" aria-hidden="true"></i> รีเฟรช-->
<!--              </button>-->
          </div>
        </div>

        <div class="role-tabs-bar" aria-label="กรองสถานะการจำหน่าย">
          @for (tab of statusTabs; track tab.value) {
            <button type="button"
                    class="role-tab"
                    [class.active]="activeTab() === tab.value"
                    (click)="selectTab(tab.value)">
              {{ tab.label }}
              @if (tab.value === 'ALL' && visibleRecords().length > 0) {
                <span class="tab-count">{{ visibleRecords().length }}</span>
              }
              @if (tab.value === 'SOLD' && soldCount() > 0) {
                <span class="tab-count">{{ soldCount() }}</span>
              }
            </button>
          }
          <div class="kind-filter-wrap">
            <label class="visually-hidden" for="trade-product">สินค้า</label>
            <select id="trade-product" class="form-select form-select-sm" [value]="selectedProduct()"
                    (change)="onProductChange($event)">
              <option value="">สินค้าทั้งหมด</option>
              @for (name of productOptions(); track name) {
                <option [value]="name">{{ name }}</option>
              }
            </select>
            <label class="visually-hidden" for="trade-kind">ประเภท</label>
            <select id="trade-kind" class="form-select form-select-sm" [value]="kindFilter()"
                    (change)="onKindChange($event)">
              @for (option of kindOptions; track option.value) {
                <option [value]="option.value">{{ option.label }}</option>
              }
            </select>
          </div>
        </div>

        <div class="result-line">
          พบ {{ filteredRecords().length.toLocaleString('th-TH') }} รายการ
        </div>

        @if (recordsLoading()) {
          <div class="d-flex justify-content-center align-items-center py-5">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">กำลังโหลด…</span>
            </div>
          </div>
        } @else if (filteredRecords().length === 0) {
          <div class="record-empty-state">
            <i class="bi bi-basket2 empty-state-icon" aria-hidden="true"></i>
            <strong>ยังไม่มีข้อมูลรายการซื้อ-ขาย</strong>
            <span>บันทึกผลผลิตหรือสแกน QR เพื่อเริ่มต้นติดตามเส้นทางสินค้าเกษตร</span>
          </div>
        } @else {
          <!-- ตาราง (จอกลางขึ้นไป) -->
          <div class="d-none d-md-block table-responsive record-table-shell">
            <table class="table table-hover align-middle mb-0 record-table">
              <thead class="table-light text-secondary">
              <tr>
                <th scope="col" style="width: 52px;">#</th>
                <th scope="col" class="ps-3">สินค้า</th>
                <th scope="col">รหัสรายการ / วันที่</th>
                <th scope="col">ผู้ขาย → ผู้ซื้อ</th>
                <th scope="col" class="text-end">ปริมาณรวม</th>
                <th scope="col" class="text-end">จำหน่ายแล้ว</th>
                <th scope="col" class="text-end">คงเหลือ</th>
                <th scope="col">สถานะสต็อก</th>
                <th scope="col" class="text-start pe-3" style="width: 110px;">การจัดการ</th>
              </tr>
              </thead>
              <tbody>
                @for (record of pagedRecords(); track record.id; let i = $index) {
                  <tr class="trade-row" tabindex="0" (click)="openRecord(record)"
                      (keydown.enter)="openRecord(record)">
                    <td class="text-muted">{{ recordRowNumber(i).toLocaleString('th-TH') }}</td>
                    <td class="record-product-cell ps-3">
                      <div class="d-flex align-items-center gap-2">
                        <div class="record-thumb">
                          <app-fruit-icon class="table-fruit-icon" [product]="record.productName || ''"
                                          [imageUrl]="record.productImageUrl ?? null"></app-fruit-icon>
                        </div>
                        <div class="min-w-0">
                          <span class="record-product-name">{{ record.productName || 'ไม่ระบุสินค้า' }}</span>
                          <span class="record-product-meta">
                            <span class="sub">{{ tradeRecordLabel(record) }}</span>
                          </span>
                        </div>
                      </div>
                    </td>
                    <td (click)="$event.stopPropagation();">
                      <app-record-code [code]="record.recordCode"/>
                      <span class="sub">{{ (recordDate(record) | thaidatetime: {showTime: false}) || '-' }}</span>
                    </td>
                    <td class="flow-cell">
                      <span class="flow-from">{{ flowFrom(record) }}</span>
                      @if (flowTo(record); as buyer) {
                        <span class="flow-arrow" aria-hidden="true">→</span>
                        <span class="flow-to">{{ buyer }}</span>
                      }
                    </td>
                    <td class="text-end text-nowrap">{{ formatQuantityWithUnit(record.quantity, record.unit) }}</td>
                    <td class="text-end text-nowrap">{{ formatQuantityWithUnit(record.soldQty, record.unit) }}</td>
                    <td class="text-end text-nowrap">{{ formatQuantityWithUnit(record.remainingQty, record.unit) }}
                    </td>
                    <td>
                      <span
                        [class]="'pill ' + recordSaleStatusClass(record)">{{ recordSaleStatusLabel(record) }}</span>
                    </td>
                    <td class="text-start pe-3" (click)="$event.stopPropagation();">
                      <div class="record-actions">
                        <div ngbDropdown class="dropdown" [autoClose]="true" placement="bottom-start" container="body">
                          <button class="btn-action-pill" ngbDropdownToggle aria-label="การจัดการ"
                                  title="การจัดการ">
                            <span>จัดการ</span>
                            <i class="bi bi-chevron-down"></i>
                          </button>
                          <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end shadow border-0">
                            <button ngbDropdownItem class="d-flex gap-2 align-items-start"
                                    (click)="openRecord(record)">
                              <i class="bi bi-eye"></i> ดูรายละเอียด
                            </button>
                            @if (record.canDelete) {
                              <button ngbDropdownItem class="d-flex gap-2 align-items-start text-danger"
                                      (click)="deleteRecord(record, $event)">
                                <i class="bi bi-trash3"></i> ลบ
                              </button>
                            }
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>

          <!-- การ์ด (จอเล็ก) -->
          <div class="d-md-none record-mobile-list">
            @for (record of pagedRecords(); track record.id) {
              <div class="card record-card mb-3 border" (click)="openRecord(record)">
                <div class="card-body p-3">
                  <div class="d-flex align-items-start gap-3">
                    <div class="record-thumb flex-shrink-0">
                      <app-fruit-icon class="table-fruit-icon" [product]="record.productName || ''"
                                      [imageUrl]="record.productImageUrl ?? null"></app-fruit-icon>
                    </div>
                    <div class="flex-grow-1 min-w-0">
                      <div class="mb-1 min-w-0">
                        <h6 class="mb-0 fw-semibold text-truncate">{{ record.productName || 'ไม่ระบุสินค้า' }}</h6>
                        <div class="d-flex align-items-center gap-1 mt-1 min-w-0">
                          <span
                            [class]="'pill ' + recordSaleStatusClass(record)">{{ recordSaleStatusLabel(record) }}</span>
                          <span class="text-secondary small">{{ tradeRecordLabel(record) }}</span>
                        </div>
                      </div>
                      @if (record.kind === 'PURCHASE') {
                        <p class="mb-1 text-muted small text-break">
                          <i class="bi bi-arrow-left-right me-1"></i>
                          {{ flowFrom(record) }}
                          @if (flowTo(record); as buyer) {
                            <span aria-hidden="true"> → </span>{{ buyer }}
                          }
                        </p>
                      }
                      <p class="mb-1 text-muted small">
                        <i class="bi bi-calendar3 me-1"></i>
                        {{ (recordDate(record) | thaidatetime: {showTime: false}) || '-' }}
                        · {{ record.lotCode || '—' }}
                      </p>
                      <div class="record-stats">
                        <div class="record-stat">
                          <span class="stat-label">ปริมาณรวม</span>
                          <span class="stat-value">
                            <span class="stat-num">{{ formatQuantity(record.quantity) }}</span>
                            @if (record.unit) {
                              <span class="stat-unit">{{ shortUnit(record.unit) }}</span>
                            }
                          </span>
                        </div>
                        <div class="record-stat">
                          <span class="stat-label">จำหน่ายแล้ว</span>
                          <span class="stat-value">
                            <span class="stat-num">{{ formatQuantity(record.soldQty) }}</span>
                            @if (record.unit) {
                              <span class="stat-unit">{{ shortUnit(record.unit) }}</span>
                            }
                          </span>
                        </div>
                        <div class="record-stat">
                          <span class="stat-label">คงเหลือ</span>
                          <span class="stat-value">
                            <span class="stat-num">{{ formatQuantity(record.remainingQty) }}</span>
                            @if (record.unit) {
                              <span class="stat-unit">{{ shortUnit(record.unit) }}</span>
                            }
                          </span>
                        </div>
                      </div>
                      <div class="record-card-footer mt-2 pt-2 border-top"
                           (click)="$event.stopPropagation();">
                        <div class="mb-2">
                          <app-record-code [code]="record.recordCode"/>
                        </div>
                        <div class="record-actions w-100">
                          <div ngbDropdown class="dropdown dropup w-100" [autoClose]="true" placement="top top-end top-start bottom bottom-end bottom-start"
                               container="body">
                            <button class="btn-action-pill w-100 justify-content-center" ngbDropdownToggle aria-label="การจัดการ"
                                    title="การจัดการ">
                              <span>จัดการ</span>
                              <i class="bi bi-chevron-down"></i>
                            </button>
                            <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end align-items-start shadow border-0">
                              <button ngbDropdownItem class="d-flex gap-2"
                                      (click)="openRecord(record)">
                                <i class="bi bi-eye"></i> ดูรายละเอียด
                              </button>
                              @if (record.canDelete) {
                                <button ngbDropdownItem class="d-flex align-items-start gap-2 text-danger"
                                        (click)="deleteRecord(record, $event)">
                                  <i class="bi bi-trash3"></i> ลบ
                                </button>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
          @if (filteredRecords().length > 5 && pagedRecords().length < filteredRecords().length) {
            <div class="load-more-wrap">
              <button type="button" class="btn btn-load-more" (click)="loadMoreRecords()">
                <span>เพิ่มเติม</span>
                <i class="bi bi-chevron-down" aria-hidden="true"></i>
              </button>
            </div>
          }
        }
      </div>
    </section>
    }
  }
</div>
